<template>
    <el-dialog
        :before-close="uploadHandleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="uploadVisible"
        width="35%"
        title="批量导入"
        v-el-drag-dialog
        ref="refDialogUpload"
        v-loading="loading"
    >
        <el-dialog
            append-to-body
            :before-close="uploadHandleClose2"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="innerVisible"
            width="35%"
            title="上传结果"
            v-el-drag-dialog
        >
            成功条数:{{ successCount }}
            <el-table
                :data="tableData"
                size="mini"
                style="width: 100%; margin-top: 10px"
                border
            >
                <el-table-column prop="rowIndex" label="行数"></el-table-column>
                <el-table-column
                    prop="errorData"
                    label="错误原因"
                ></el-table-column>
            </el-table>
        </el-dialog>
        <el-upload
            ref="upload"
            class="upload-demo"
            :action="apiURL"
            :limit="1"
            :file-list="fileList"
            :before-upload="beforeUpload"
            style="padding-bottom: 20px"
        >
            <el-button icon="el-icon-upload" class="right-20"
                >点击上传模板</el-button
            >
            <div slot="tip" class="el-upload__tip">
                请先下载模板，再编辑上传，仅支持excel格式文件
            </div>
        </el-upload>
        <span slot="footer">
            <el-button
                type="info"
                size="medium"
                @click="closeFileUpload"
                icon="el-icon-close"
                >关闭</el-button
            >
            <el-button
                type="primary"
                size="medium"
                @click="submitFile"
                icon="el-icon-check"
                >上传</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    props: {
        apiURL: {
            type: String,
            required: true
        },
        // afterUploadFunc: {
        //   type: Function,
        //   required: true,
        //   default: function() {}
        // },
        Refresh: {
            type: Function,
            required: true,
            default: function () {}
        },
        OtherParams: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            uploadVisible: false,
            fileList: [],
            files: {},
            innerVisible: false,
            tableData: [],
            successCount: 0,
            loading: false
        }
    },
    methods: {
        open() {
            this.uploadVisible = true
        },
        uploadHandleClose(d) {
            this.closeFileUpload()
            d()
        },
        uploadHandleClose2(d) {
            d()
        },
        closeFileUpload() {
            this.fileList = []
            this.uploadVisible = false
            this.files = {}
        },
        beforeUpload(file) {
            const _this = this
            _this.fileList = []
            _this.files = file
            const extension = file.name.split('.')[1] === 'xls'
            const extension2 = file.name.split('.')[1] === 'xlsx'
            const isLt2M = file.size / 1024 / 1024 < 5
            if (!extension && !extension2) {
                _this.$message.warning('上传模板只能是 xls、xlsx格式!')
            }
            if (!isLt2M) {
                _this.$message.warning('上传模板大小不能超过 5MB!')
            }
            var isSubmit = (extension || extension2) && isLt2M
            if (isSubmit) {
                _this.fileList.push(file)
            }
            return false
        },
        submitFile() {
            const _this = this
            _this.loading = true
            if (!_this.files.name) {
                _this.$message.warning('请选择要上传的文件！')
                return false
            }
            let fileFormData = new FormData()
            //filename是键，file是值，就是要传的文件
            fileFormData.append('file', _this.files, _this.files.name)
            if (_this.OtherParams) {
                const keys = Object.keys(_this.OtherParams)
                keys.forEach((e) => {
                    fileFormData.append(e, _this.OtherParams[e])
                })
            }
            let requestConfig = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            AjaxHelper.post(_this.apiURL, fileFormData, requestConfig)
                .then((res) => {
                    if (res.success) {
                        const result = res.result
                        if (result.errorCount == 0 && result.successCount > 0) {
                            _this.$message({
                                message: `导入成功,成功${result.successCount}条`,
                                type: 'success'
                            })
                            _this.closeFileUpload()
                            _this.Refresh()
                        } else if (
                            result.errorCount > 0 &&
                            result.successCount >= 0
                        ) {
                            _this.Refresh()
                            _this.tableData = result.uploadErrors
                            _this.successCount = result.successCount
                            _this.innerVisible = true
                        } else if (
                            result.errorCount == 0 &&
                            result.successCount == 0
                        ) {
                            _this.$message({
                                message: `上传文件中数据为空`,
                                type: 'error'
                            })
                        }
                        _this.loading = false
                    }
                })
                .catch(function (error) {
                    _this.loading = false
                    console.log(error)
                })
        },
        beforeUpload(file) {
            //验证选中文件的正确性
            const _this = this
            _this.fileList = []
            _this.files = file
            const extension = file.name.split('.')[1] === 'xls'
            const extension2 = file.name.split('.')[1] === 'xlsx'
            const isLt2M = file.size / 1024 / 1024 < 5
            if (!extension && !extension2) {
                _this.$message.warning('上传模板只能是 xls、xlsx格式!')
            }
            if (!isLt2M) {
                _this.$message.warning('上传模板大小不能超过 5MB!')
            }
            var isSubmit = (extension || extension2) && isLt2M
            if (isSubmit) {
                _this.fileList.push(file)
            }
            return false
        }
    }
}
</script>

<style>
</style>
